import React from 'react';
import dotAccess from 'dot-access';
import {filterValue} from './filterValue';
import './OutputBox.css';
import {booleanFormatter, dateFormatter} from '../../functions/textFormatter';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';


export const Show_IfNOT_Mutagen_Cancerous = ({children, ...other}) => {
    if (other.resource !== undefined) {

        if ((other.resource.isSubstanceCancerous === false || other.resource.isSubstanceCancerous === null || other.resource.isSubstanceCancerous == undefined) &&
            (other.resource.isSubstanceMutagen === false || other.resource.isSubstanceMutagen === null || other.resource.isSubstanceMutagen == undefined)) {

            return React.cloneElement(React.Children.only(children), {
                ...other,
            });
        }
    }

    if (other.value != undefined) {

        if ((other.value.isSubstanceCancerous === false || other.value.isSubstanceCancerous === null || other.value.isSubstanceCancerous === undefined) &&
            (other.value.isSubstanceMutagen === false || other.value.isSubstanceMutagen === null || other.value.isSubstanceMutagen === undefined)) {

            return React.cloneElement(React.Children.only(children), {
                ...other,
            });
        }
    }


    return (<span></span>);

};

export const Show_If_Mutagen_Cancerous = ({children, ...other}) => {
    if (other.resource !== undefined) {
        if ((other.resource.isSubstanceCancerous) ||
            (other.resource.isSubstanceMutagen)) {

            return React.cloneElement(React.Children.only(children), {
                ...other,
            });
        }


    }


    if (other.value !== undefined) {
        if ((other.value.isSubstanceCancerous) ||
            (other.value.isSubstanceMutagen)) {

            return React.cloneElement(React.Children.only(children), {
                ...other,
            });
        }
    }
    return (<span></span>);

};

export const Show_If_LastSDSBeenAcknowledged = ({children, ...other}) => {
    if (other.resource !== undefined) {
        if (other.resource.hasLastSDSBeenAcknowledged) {

            return React.cloneElement(React.Children.only(children), {
                ...other,
            });
        }
    }

    if (other.value !== undefined) {
        if (other.value.hasLastSDSBeenAcknowledged) {
            return React.cloneElement(React.Children.only(children), {
                ...other,
            });
        }
    }

    return (<span></span>);
};

export const OutputBoxContent = (props, context) => {
    const child = React.cloneElement(React.Children.only(props.children), {
        resource: props.name ? dotAccess.get(props.resource, props.name) : props.resource,
        updateResults: props.updateResults,
        toggleModal: props.toggleModal,
    });

    //XXX FME: Probabilmente si può fare in altro modo
    //  if((!props.resource.isSubstanceCancerous || props.resource.isSubstanceCancerous == null || props.resource.isSubstanceCancerous == undefined) &&
    //     (!props.resource.isSubstanceMutagen || props.resource.isSubstanceMutagen == null || props.resource.isSubstanceMutagen == undefined) &&
    //		     props.label === "substancesManagement.handlingTemperature.displayLabel"){
    //
    //			  return (null);
    //  }

    return (
        <div className="OutputBox" style={props.style}>
            <div className="output-label">{getLabel(context.locale, props.label)}</div>
            <div className="output-content">
                {child}
            </div>
        </div>
    );

};

OutputBoxContent.contextTypes = {
    locale: PropTypes.string,
};

export const OutputBoxBoolean = props => (
    <OutputBox formatter={booleanFormatter} {...props} />
);

export const OutputBoxDate = props => (
    <OutputBox formatter={dateFormatter} {...props} />
);

const OutputBox = (props, context) => (
    <div className="OutputBox" style={props.style}>
        <div className="output-label">{getLabel(context.locale, props.label)}</div>
        <div className="output-content">{filterValue(props)}</div>
    </div>
);

OutputBox.contextTypes = {
    locale: PropTypes.string,
};

export default OutputBox;



// WEBPACK FOOTER //
// ./src/main/components/output/OutputBox.js